var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5449 5.9435C14.0884 3.29748 17.9116 3.29748 19.4551 5.9435L28.8123 21.9845C30.3679 24.6511 28.4444 28 25.3572 28H6.64274C3.55558 28 1.6321 24.6511 3.18763 21.9845L12.5449 5.9435ZM17 13.3333C17 12.781 16.5523 12.3333 16 12.3333C15.4477 12.3333 15 12.781 15 13.3333V17.3333C15 17.8856 15.4477 18.3333 16 18.3333C16.5523 18.3333 17 17.8856 17 17.3333V13.3333ZM16 20.3333C15.4477 20.3333 15 20.781 15 21.3333C15 21.8856 15.4477 22.3333 16 22.3333H16.0133C16.5656 22.3333 17.0133 21.8856 17.0133 21.3333C17.0133 20.781 16.5656 20.3333 16.0133 20.3333H16Z",
    fill: "#E03127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCritical);
export default __webpack_public_path__ + "static/media/alert-critical.e55f23cf7c6acf7261ccf9519b213caf.svg";
export { ForwardRef as ReactComponent };